import ApplicationCulture from '../config/ApplicationCulture.js';
import TypeHelper from './TypeHelper.js';
import NumberHelper from './NumberHelper.js';
import StringHelper from './StringHelper.js';

const HtmlHelper = (function() {

    const _selectingKeys = Object.freeze([
        "Home", "End", "ArrowUp", "ArrowRight", "ArrowLeft", "ArrowDown"
    ]);

    const _helper = {
        SelectingKeys: _selectingKeys,
    };

    return Object.freeze(_helper);

})();

export default HtmlHelper;